import { FC } from 'react';
import { BUTTON_SIZES, BUTTON_VARIANTS, ChatButton, IconButton } from 'ui/button';
import { Hamburger24 } from 'ui/icons/aurora/24px/Hamburger24';
import { LongArrowLeft24 } from 'ui/icons/aurora/24px/LongArrowLeft24';
import { NavBarContainer, NavContent, Title } from './NavBar.styled';
import { NavBarProps, NavBarVariant } from './NavBar.types';

export const DEFAULT_ID = 'nav-bar';

/**
 * Utility function to get proper theme styles for the buttons in the Nav Bar
 * @param variant
 * @returns props to use for the nav buttons
 */
export const getNavButtonProps = (variant: NavBarVariant) => ({
  size: BUTTON_SIZES.LARGE,
  variant: variant === NavBarVariant.Focus ? BUTTON_VARIANTS.GHOST : BUTTON_VARIANTS.GHOSTINVERTED,
});

export const NavBar: FC<NavBarProps> = ({
  id = DEFAULT_ID,
  BackIcon = LongArrowLeft24,
  MenuIcon = Hamburger24,
  ContentLeft,
  ContentRight,
  onBackClick,
  onMenuClick,
  menuRef,
  showChatButton,
  title,
  variant = NavBarVariant.Edit,
  ...props
}) => {
  const buttonProps = getNavButtonProps(variant);
  return (
    <NavBarContainer variant={variant} data-test={id} {...props}>
      <NavContent>
        {onMenuClick && (
          <IconButton
            data-test={`${id}-hamburger`}
            ref={menuRef}
            onClick={onMenuClick}
            {...buttonProps}
          >
            <MenuIcon isColorInherited />
          </IconButton>
        )}
        {onBackClick && (
          <IconButton
            data-test={`${id}-go-back`}
            id={`${id}-go-back`}
            onClick={onBackClick}
            {...buttonProps}
          >
            <BackIcon isColorInherited />
          </IconButton>
        )}
        {title && <Title variant={variant}>{title}</Title>}
        {ContentLeft}
      </NavContent>
      <NavContent>
        {showChatButton && <ChatButton />}
        {ContentRight}
      </NavContent>
    </NavBarContainer>
  );
};
